/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FeedSignalCreate = {
    properties: {
        userText: {
            type: 'string',
            isRequired: true,
        },
        postId: {
            type: 'number',
            isRequired: true,
        },
        commentId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
